import { useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom"; 
import red_line from '../../img/red_line.png';
import HeaderIndex from './components/HeaderIndex';
import Footer from '../../components/footer/Footer';
import Image from './components/Image';
import Header from '../../components/header/Header';
import './Index.css';
import RadioButton from '../../components/common/radioButton/RadioButton';
function Index() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const customersChoice = () => {
    navigate("/customers");
  };

  const checkStatus = () => {
    navigate("/status");
  };

  return (
    <div className='start-page'>
      <HeaderIndex />
      <div className='frame-774'>
        <div className='frame-775'>
          <div className='why-PRO'>
            <div className='title-header'>
              <img src={red_line} style={{ left: '-10px' }} className='red-line' />
              <h3 className='header-text'>
                system elektronicznej<br /> rejestracji reklamacji
              </h3>
              {/* <div className="holiday-text">
            <h4>
              Niniejszym informujemy, że: <br />
              <ul>
                <li>
                  <u>
                    w okresie 18.12.2023 r. - 05.01.2024 r  nastąpi przerwa w
                    obsłudze reklamacji.
                  </u>
                </li>
                <li>
                  Reklamacje zarejestrowane w systemie do dnia 15.12.2023 r.
                  będą jeszcze odbierane od klientów do 19.12.2023 r. ale
                  rozpatrywane od 08.01.2024 r.
                </li>
                <li>
                  Reklamacje zarejestrowane w systemie od dnia 18.12.2023 r.
                  będą odbierane od klientów od 08.01.2024 r.
                </li>
              </ul>
              Przepraszamy za utrudnienia.
            </h4>
          </div> */}
            </div>

            <div className='start-buttons-container'>
              <button className='button-1' onClick={customersChoice}>
                Zgłoś reklamację
              </button>
              <button className='button-2' onClick={checkStatus}>
                Sprawdź status
              </button>
            </div>
          </div>

          <div className='frame-772'>
            <div className='frame-773'>
              <p className='text-773'>
                Chcesz odpłatnie skalibrować lub naprawić produkty PRO?
              </p>
              <button className='btn-773' onClick={customersChoice}>
                Zgłoś sprzęt do naprawy
              </button>
            </div>
          </div>

         
        </div>
      </div>
      <Image />
      <Footer />
    </div>
  );
}

export default Index;